<template lang="pug">
  v-container.fill-height.align-start.pa-0(max-width="600px")
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-container.pl-0
      v-card.elevation-0(flat)
        v-card-title {{ $t('settingsPage.configuration.customerSettingTitle') }}
        v-card-text
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="dashboard"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Dashboard")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="denneMenu"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Denné menu")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="objednavky"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Objednávky")
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="rating"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Hodnotenia objednávok")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="boarders"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Stravníci")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="discounts"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Zľavy")
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="delivery"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Rozvoz")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="foodDatabse"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Databáza jedál")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="calendar"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Kalendár")
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="billing"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Vyúčtovania")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="bankStattements"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Bankové prevody")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="debtors"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Neplatiči")
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="requests"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Žiadosti")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="smartLinks"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Smart linky")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="statistics"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Štatistiky")
          v-row.ma-0
            v-col.text-end(cols="12")
              v-btn(@click="onSaveButtonClick" :loading="saveInProgress" color="primary") {{ $t('settingsPage.configuration.save') }}
      v-divider
      v-card.elevation-0(flat)
        v-card-title {{ $t('settingsPage.configuration.appSettingTitle') }}
        v-card-text
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="dashboardApp"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Dashboard")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="dailyMenu"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Denné menu")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="myOrders"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Moje objenávky")
          v-row.ma-0
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="credit"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Kredit")
            v-col.pa-0(cols="12" md="4")
              v-checkbox(v-model="billingApp"
                on-icon="fas fa-check-square"
                off-icon="far fa-square"
                label="Moje vyúčtovania")
          v-row.ma-0
            v-col.text-end(cols="12")
              v-btn(@click="saveButtonClick" :loading="isSaveInProgress" color="primary") {{ $t('settingsPage.configuration.save') }}
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from "vuex-class";
import { GET_KEY, GET_SETTING_DATA, SAVE_NEW_SETTING, SAVE_SETTINGS} from "@/store/action-types";
import {SettingsPayload} from "@/types/payload";
import SettingsKeyList from "@/model/SettingsKeyList";
import KeyList from "@/model/KeyList";
import {GET_KEY_LIST} from "@/store/getter-types";

@Component({
  components: {

  }
})
export default class MainMenuPage extends Vue {
  @Action(GET_KEY) fetchKey!: ({ (): Promise<any[]> })
  @Action(GET_SETTING_DATA) fetchSettingData!: ({ (): Promise<SettingsKeyList[]> })
  @Action(SAVE_NEW_SETTING) updateExistingSettings!: ({ (payload: SettingsPayload): Promise<void> })
  @Action(SAVE_SETTINGS) createSettings!: ({ (payload: any): Promise<void> })

  private fetchInProgress: boolean = false
  private isFetchInProgress: boolean = false
  private saveInProgress: boolean =false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private dashboard: boolean = true
  private denneMenu: boolean = true
  private objednavky: boolean = true
  private rating: boolean = true
  private boarders: boolean = true
  private discounts: boolean = true
  private delivery: boolean = true
  private foodDatabse: boolean = true
  private calendar: boolean = true
  private billing: boolean = true
  private debtors: boolean = true
  private requests: boolean = true
  private smartLinks: boolean = true
  private statistics: boolean = true
  private bankStattements: boolean = true
  private keyList: KeyList[] | null = []
  private settingsKeyList: SettingsKeyList[] | null = []
  private dashboardApp: boolean = true
  private dailyMenu: boolean = true
  private myOrders: boolean = true
  private credit: boolean = true
  private billingApp: boolean = true
  private isSaveInProgress: boolean = false


  getData() {
    this.keyList!.forEach((item:any) => {
      if(item.key === 'tenant.cp_main_menu_structure' && item.value !== '[]') {
        if(item.value.includes('dashboard')) {
          this.dashboard = true
        } else {
          this.dashboard = false
        }
        if(item.value.includes('daily_menu')) {
          this.denneMenu = true
        } else {
          this.denneMenu = false
        }
        if(item.value.includes('offer_reservations_lc')) {
          this.objednavky = true
        } else {
          this.objednavky = false
        }
        if(item.value.includes('offer_reservation_rating')) {
          this.rating = true
        } else {
          this.rating = false
        }
        if(item.value.includes('boarders')) {
          this.boarders = true
        } else {
          this.boarders = false
        }
        if(item.value.includes('discounts')) {
          this.discounts = true
        } else {
          this.discounts = false
        }
        if(item.value.includes('delivery')) {
          this.delivery = true
        } else {
          this.delivery = false
        }
        if(item.value.includes('food_database')) {
          this.foodDatabse = true
        } else {
          this.foodDatabse = false
        }
        if(item.value.includes('calendar')) {
          this.calendar = true
        } else {
          this.calendar = false
        }
        if(item.value.includes('billing')) {
          this.billing = true
        } else {
          this.billing = false
        }
        if(item.value.includes('bank_statements')) {
          this.bankStattements = true
        } else {
          this.bankStattements = false
        }
        if(item.value.includes('debtors')) {
          this.debtors = true
        } else {
          this.debtors = false
        }
        if(item.value.includes('requests')) {
          this.requests = true
        } else {
          this.requests = false
        }
        if(item.value.includes('smart_links')) {
          this.smartLinks = true
        } else {
          this.smartLinks = false
        }
        if(item.value.includes('stats')) {
          this.statistics = true
        } else {
          this.statistics = false
        }
      } else if(item.key === 'tenant.app_main_menu_structure' && item.value !== '[]') {
        if (item.value.includes('dashboard')) {
          this.dashboardApp = true
        } else {
          this.dashboardApp = false
        }
        if (item.value.includes('daily_menu')) {
          this.dailyMenu = true
        } else {
          this.dailyMenu = false
        }
        if (item.value.includes('credit')) {
          this.credit = true
        } else {
          this.credit = false
        }
        if (item.value.includes('billing')) {
          this.billingApp = true
        } else {
          this.billingApp = false
        }
        if (item.value.includes('my_orders')) {
          this.myOrders = true
        } else {
          this.myOrders = false
        }
      }

    })


  }

  saveButtonClick() {
    let id: string = ''
    let payload: string[] = []
    if(this.dashboardApp) {
      payload.push('dashboard')
    }
    if(this.dailyMenu) {
      payload.push('daily_menu')
    }
    if(this.myOrders) {
      payload.push('my_orders')
    }
    if(this.credit) {
      payload.push('credit')
    }
    if(this.billingApp) {
      payload.push('billing')
    }
    const foundItem: any = this.keyList!.find((i:any) => i.key === "tenant.app_main_menu_structure")
    if(foundItem) {

      id = foundItem.id
    }
    if(id !== '') {
      this.updateAppSettings(payload,id)
    } else {
      this.saveNewSettings(payload)
    }

  }

  onSaveButtonClick () {
    let id: string = ''
    let payload: string[] = []
    if(this.dashboard) {
      payload.push('dashboard')
    }
    if(this.denneMenu) {
      payload.push('daily_menu')
    }

    if(this.objednavky) {
      payload.push('offer_reservations_lc')
    }
    if(this.rating) {
      payload.push('offer_reservation_rating')
    }
    if(this.boarders) {
      payload.push('boarders')
    }
    if(this.discounts) {
      payload.push('discounts')
    }
    if(this.delivery) {
      payload.push('delivery')
    }
    if(this.foodDatabse) {
      payload.push('food_database')
    }
    if(this.calendar) {
      payload.push('calendar')
    }
    if(this.billing) {
      payload.push('billing')
    }
    if(this.debtors) {
      payload.push('debtors')
    }
    if(this.requests) {
      payload.push('requests')
    }
    if(this.bankStattements) {
      payload.push('bank_statements')
    }
    if(this.smartLinks) {
      payload.push('smart_links')
    }
    if(this.statistics) {
      payload.push('stats')
    }
    const foundItem: any = this.keyList!.find((i:any) => i.key === "tenant.cp_main_menu_structure")
      if(foundItem) {
        id = foundItem.id
      }
    if(id !== '') {
      this.updateSettings(payload,id)
    } else {
      this.saveSettings(payload)
    }

  }

  async updateAppSettings(item: any,id: string): Promise<void> {
    let payload: any = {
      id: id,
      value: JSON.stringify(item)
    }
    this.isSaveInProgress = true
    try {
      await this.updateExistingSettings(payload)
      this.fetchSettingsKeys()
    }catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingNotSaved').toString()
    }finally {
      this.isSaveInProgress = false
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingSaved').toString()
    }
  }

  async updateSettings(item: any,id: string): Promise<void> {
    let payload: any = {
      id: id,
      value: JSON.stringify(item)
    }
    this.saveInProgress = true
    try {
      await this.updateExistingSettings(payload)
      this.fetchSettingsKeys()
    }catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingNotSaved').toString()
    }finally {
      this.saveInProgress = false
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingSaved').toString()
    }
  }

  async saveSettings(item: string[]): Promise<void> {
    let payload: any = {
      key: "tenant.cp_main_menu_structure",
      value: JSON.stringify(item)
    }

    this.saveInProgress = true
    try {
      await this.createSettings(payload)
      this.fetchSettingsKeys()
    }catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingNotSaved').toString()

    }finally {
      this.saveInProgress = false
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingSaved').toString()
    }
  }

  async saveNewSettings(item: string[]): Promise<void> {
    let payload: any = {
      key: "tenant.app_main_menu_structure",
      value: JSON.stringify(item)
    }

    this.isSaveInProgress = true
    try {
      await this.createSettings(payload)
      this.fetchSettingsKeys()
    }catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingNotSaved').toString()

    }finally {
      this.isSaveInProgress = false
      this.showSnackBar = true
      this.snackBarColor = 'success'
      this.snackBarMessage = this.$t('settingsPage.configuration.settingSaved').toString()
    }
  }

  async fetchSettingsKeys(): Promise<any> {
    try {
      this.isFetchInProgress = true
      this.keyList = await this.fetchKey()
      this.getData()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }finally {
      this.isFetchInProgress = false
    }
  }

  async fetchSettingsData(): Promise<any> {
    try {
      this.isFetchInProgress = true
      this.settingsKeyList = await this.fetchSettingData()
      this.getData()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }finally {
      this.isFetchInProgress = false
    }
  }




   mounted () {
     this.keyList = this.$store.getters[GET_KEY_LIST]
     this.getData()
     this.fetchSettingsData()
  }
}
</script>

<style lang="stylus" scoped>

</style>
